import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { TankatableregistrationManageInfo } from 'sg-api';
import { SearchStat } from '../../../../../sg-kc-shared/constants/searchStat';

/**単価表登録画面 （承認情報）
 * @export
 * @class Sgkc012dTankaTableApprovalInfoComponent
 * @implements {OnInit,OnDestroy} 
 */
@Component({
    selector: 'app-sgkc012d-tanka-table-approval-info',
    templateUrl: './sgkc012d-tanka-table-approval-info.component.html',
    styleUrl: './sgkc012d-tanka-table-approval-info.component.scss'
})
export class Sgkc012dTankaTableApprovalInfoComponent implements OnInit, OnDestroy {
    /** 単価表登録管理情報 */
    @Input() tankatableregistrationManageInfo: TankatableregistrationManageInfo;
    /** 画面モード */
    @Input() mode: string;

    /** ステータス */
    approvalstatus = this.fb.control({ value: '', disabled: true });
    /** 登録部署 */
    regDepartmentname = this.fb.control({ value: '', disabled: true });
    /** 登録者 */
    registrantname = this.fb.control({ value: '', disabled: true });
    /** 登録日時 */
    regDateTime = this.fb.control({ value: '', disabled: true });
    /** 承認部署 */
    apprvDepartmentname = this.fb.control({ value: '', disabled: true });
    /** 承認者 */
    approvername = this.fb.control({ value: '', disabled: true });
    /** 承認日時 */
    apprvDateTime = this.fb.control({ value: '', disabled: true });
    /** 単価表承認情報保持Form */
    tankatableregistrationManageInfoForm: UntypedFormGroup = this.fb.group({
        approvalstatus: this.approvalstatus,
        regDepartmentname: this.regDepartmentname,
        registrantname: this.registrantname,
        regDateTime: this.regDateTime,
        apprvDepartmentname: this.apprvDepartmentname,
        approvername: this.approvername,
        apprvDateTime: this.apprvDateTime,
    })
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;

    /** 単価表承認情報表示フラグ */
    tankatableregistrationManageInfoFormVisible: boolean = true;

    /**
     * コンストラクタ
     * @param {FormGroupDirective} parent
     * @param {UntypedFormBuilder} fb
     * @memberof Sgkc012dTankaTableApprovalInfoComponent
     */
    constructor(
        private parent: FormGroupDirective,
        private fb: UntypedFormBuilder,
    ) { }

    /** 
    * 初期処理
    * @memberof Sgkc012dTankaTableApprovalInfoComponent
    */
    ngOnInit(): void {
        // 登録日時のフォーマット
        // YYYYMMdd形式の日付を分解
        const regDateFormat = this.convertDateFormat(this.tankatableregistrationManageInfo.regDate);
        const regTimeFormat = this.convertTimeFormat(this.tankatableregistrationManageInfo.registrationtime);
        // フォーマットを作成
        const regTimeDateFormat = `${regDateFormat} ${regTimeFormat}`;

        let apprvTimeDateFormat = null;
        // 承認ステータスがが承認済の場合フォーマット
        if (this.tankatableregistrationManageInfo.apprvStatuscode === SearchStat.SHONINZUMI) {

            // 承認日時のフォーマット
            const apprvDateFormat = this.convertDateFormat(this.tankatableregistrationManageInfo.apprvDate);
            const apprvTimeFormat = this.convertTimeFormat(this.tankatableregistrationManageInfo.apprvHms);
            // フォーマットを作成
            apprvTimeDateFormat = `${apprvDateFormat} ${apprvTimeFormat}`
        }

        this.parentForm = this.parent.form;
        this.parentForm.addControl('tankatableregistrationManageInfoForm', this.tankatableregistrationManageInfoForm);
        // 単価表登録管理情報FormGroupに初期値を設定
        this.tankatableregistrationManageInfoForm.controls['approvalstatus'].setValue(this.tankatableregistrationManageInfo.approvalstatus);
        this.tankatableregistrationManageInfoForm.controls['regDepartmentname'].setValue(this.tankatableregistrationManageInfo.regDepartmentname);
        this.tankatableregistrationManageInfoForm.controls['registrantname'].setValue(this.tankatableregistrationManageInfo.registrantname);
        this.tankatableregistrationManageInfoForm.controls['regDateTime'].setValue(regTimeDateFormat);
        this.tankatableregistrationManageInfoForm.controls['apprvDepartmentname'].setValue(this.tankatableregistrationManageInfo.apprvDepartmentname);
        this.tankatableregistrationManageInfoForm.controls['approvername'].setValue(this.tankatableregistrationManageInfo.approvername);
        this.tankatableregistrationManageInfoForm.controls['apprvDateTime'].setValue(apprvTimeDateFormat);
    }

    /**
    * 変更を停止する処理
    * @memberof Sgkc012dTankaTableApprovalInfoComponent
    */
    ngOnDestroy(): void {
        this.parentForm.clearValidators();
        this.parentForm.updateValueAndValidity();
        this.parentForm.removeControl('tankatableregistrationManageInfoForm');
    }

    /** 
     * 日付のフォーマット変換
     * @param {string} dateStr - YYYYMMDD形式の日付文字列
     * @returns {string} - YYYY/mm/DD 形式の文字列
     * @memberof Sgkc012dTankaTableApprovalInfoComponent
     */
    convertDateFormat(dateStr: string): string {
        // YYYYMMDD形式の文字列を受け取る
        const year = dateStr.slice(0, 4);
        const month = dateStr.slice(4, 6);
        const day = dateStr.slice(6, 8);
        // YYYY/mm/DD形式に変換して返す
        return `${year}/${month}/${day}`;
    }

    /** 
     * 時間のフォーマット変換
     * @param {string} timeStr - HHmmss形式の時間文字列
     * @returns {string} - HH:mm:ss形式の文字列
     * @memberof Sgkc012dTankaTableApprovalInfoComponent
     */
    convertTimeFormat(timeStr: string): string {
        // HHmmss形式の文字列を受け取る
        const HH = timeStr.slice(0, 2);
        const mm = timeStr.slice(2, 4);
        const ss = timeStr.slice(4, 6);
        // HH:mm:ss形式に変換して返す
        return `${HH}:${mm}:${ss}`;
    }
}
